/* Deuxpourdeux v2: teller gratis verzending in winkelmandje */
(function(){
  var DREMPEL=10000;
  function fmt(c){return '€ '+(c/100).toFixed(2).replace('.',',').replace(',00','')}
  function html(total){
    var rest=DREMPEL-total, pct=Math.max(0,Math.min(100,Math.round(total/DREMPEL*100)));
    var msg= rest>0 ? 'Nog <b>'+fmt(rest)+'</b> tot gratis verzending' : '<b>Je bestelling wordt gratis verzonden</b>';
    return '<p class="dpd-ship__msg">'+msg+'</p><div class="dpd-ship__bar" aria-hidden="true"><span style="width:'+pct+'%"></span></div>';
  }
  function place(total,count){
    var targets=[];
    var d=document.querySelector('#CartDrawer .drawer__header'); if(d) targets.push(d);
    var p=document.querySelector('#main-cart-items'); if(p) targets.push(p);
    targets.forEach(function(t){
      var el=t.parentNode.querySelector('.dpd-ship');
      if(!count){ if(el) el.remove(); return; }
      if(!el){ el=document.createElement('div'); el.className='dpd-ship'; t.insertAdjacentElement(t.id==='main-cart-items'?'beforebegin':'afterend',el); }
      el.innerHTML=html(total);
    });
  }
  function refresh(){ fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){place(c.total_price,c.item_count)}).catch(function(){}); }
  var of=window.fetch;
  window.fetch=function(){
    var u=(arguments[0]&&arguments[0].url)||String(arguments[0]);
    var pr=of.apply(this,arguments);
    if(/\/cart\/(add|change|update|clear)/.test(u)) pr.then(function(){setTimeout(refresh,350)});
    return pr;
  };
  document.addEventListener('DOMContentLoaded',refresh);
  new MutationObserver(function(m){ if(document.querySelector('#CartDrawer .drawer__header') && !document.querySelector('#CartDrawer .dpd-ship')) refresh(); }).observe(document.documentElement,{childList:true,subtree:true});
})();
